import React from 'react';
import {Navigate} from "react-router-dom";
import {Box, CircularProgress} from "@mui/material";
import {useUserAuth} from "./UserAuthContext";

/**
 * Guarda uma rota para utilizadores autenticados (qualquer papel).
 * Espera o Firebase terminar de restaurar a sessão antes de decidir.
 */
const ProtectedRoute = ({children}) => {

    const {user, authLoading} = useUserAuth();

    if (authLoading) {
        return (
            <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "40vh"}}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        // Sem sessão (ex.: após "Sair" no dashboard): volta à página inicial
        // em vez da página de login (que continua a servir o login em si).
        return <Navigate to="/" replace/>;
    }

    return children;
};

export default ProtectedRoute;
